"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWatchAttributes = exports.queueElement = exports.tagNameLookup = void 0;
/* eslint-disable @typescript-eslint/explicit-function-return-type */
var NativeHTMLElement = window.HTMLElement;
var upgradeQueue = [];
exports.tagNameLookup = new Map();
function queueElement(element) {
    upgradeQueue.push(element);
}
exports.queueElement = queueElement;
var watchAttributes = null;
function setWatchAttributes(fn) {
    watchAttributes = fn;
}
exports.setWatchAttributes = setWatchAttributes;
function HTMLElement() {
    var C = this.constructor;
    var tagName = exports.tagNameLookup.get(C);
    var element;
    if (!upgradeQueue.length) {
        if (!tagName) {
            throw new Error("Coulnd't find a tagname for this ");
        }
        element = document.createElement(tagName);
    }
    else {
        element = upgradeQueue.pop();
    }
    Object.setPrototypeOf(element, C.prototype);
    watchAttributes(element, C);
    return element;
}
HTMLElement.prototype = NativeHTMLElement.prototype;
window.HTMLElement = HTMLElement;
//# sourceMappingURL=module.js.map